import { useRef } from "react";

const useRefHook = () => {
  const refID = useRef(null);
  return refID;
};

export default useRefHook;
